import styled from 'styled-components';

import {
  ErrorSolidIcon,
  InformationCircleSolidIcon,
  TickCircleSolidIcon,
  WarningCircleSolidIcon,
} from '@sternum/web/icons';

export const SnackbarInformationIcon = styled(InformationCircleSolidIcon)``;

export const SnackbarSuccessIcon = styled(TickCircleSolidIcon)``;

export const SnackbarWarningIcon = styled(WarningCircleSolidIcon)``;

export const SnackbarErrorIcon = styled(ErrorSolidIcon)``;
